<script setup lang="ts">
import { DialogWrapper } from "vue3-promise-dialog"
import AlertContainer from "@/components/AlertContainer.vue"
import FileImportDialog from "@/components/FileImport/Dialog/Dialog.vue"
import Dropzone from "@/components/FileImport/Dropzone.vue"
import PlaygroundDialog from "@/components/FormulaPlayground/Dialog.vue"
import IntegrationDialog from "@/components/Integration/Dialog.vue"
import ListImportDialog from "@/components/ListImport/Dialog/Dialog.vue"
import ReloadPrompt from "@/components/ReloadPrompt.vue"
import ExportDialog from "@/components/Setup/DialogExport.vue"
import SetupDialog from "@/components/Setup/DialogSetup.vue"
import { useFileImportStore, useIntegrationStore, useListImportStore, usePlaygroundStore, useSetupStore } from "@/stores"
import { captureError } from "@/utils/useEngineModel"

const fileImportStore = useFileImportStore()
const listImportStore = useListImportStore()
const integrationStore = useIntegrationStore()
const playgroundStore = usePlaygroundStore()
const setupStore = useSetupStore()

async function handleDropzoneFile(files: File[]) {
  try {
    await fileImportStore.handleFileUpload(files)
  } catch (error) {
    captureError(error, { snackbar: error instanceof Error ? error.message : "Error importing file" })
  }
}
</script>

<template>
  <Suspense>
    <RouterView />
  </Suspense>
  <ReloadPrompt />
  <DialogWrapper />

  <Suspense>
    <FileImportDialog v-if="fileImportStore.dialog" />
  </Suspense>

  <Suspense>
    <ListImportDialog v-if="listImportStore.dialog" />
  </Suspense>

  <Suspense>
    <IntegrationDialog v-if="integrationStore.dialog" />
  </Suspense>

  <Suspense>
    <PlaygroundDialog v-if="playgroundStore.dialog" />
  </Suspense>

  <Suspense>
    <ExportDialog v-if="setupStore.exportDialog" />
  </Suspense>

  <Suspense>
    <SetupDialog v-if="setupStore.setupDialog" />
  </Suspense>

  <Dropzone @file-changed="handleDropzoneFile" />
  <AlertContainer />
  <div
    id="context-menu-wrapper"
    class="relative z-60"
  />
</template>
